<div class="relative overflow-x-clip lg:overflow-visible">
	<!-- Header -->
	<uc-main-header
		[heading]="headerData().title"
		[description]="headerData().description"
		backgroundStyle="bg-uni-search-clearing"
		textColor="text-white"
		descriptionColor="text-white"
	>
		<uc-search-bar-with-study-level
			class="block mt-8"
			placeholder="Search Universities"
			selectedProduct="clearing"
			[searchValue]="searchTerm()"
			[showClearingInDropdown]="true"
			(navigate)="onSearch($event)"
		/>
	</uc-main-header>

	<!-- Dark Overlay -->
	<uc-filter-dark-overlay
		[showOverlay]="filterTogglerSrv.displayFilter"
		(click)="filterTogglerSrv.toggle(false)"
	/>

	<div class="container py-12" id="university-search-container">
		@if (firstLoad) {
			<uc-universities-skeleton />
		} @else if (universities()) {
			<div class="flex justify-between w-full">
				<!-- Filter -->
				<uc-universities-filter
					class="flex-shrink-0 block lg:flex course-search-filter"
					[ngClass]="{
						open: filterTogglerSrv.displayFilter,
					}"
					[product]="product"
					[clearingEnabled]="clearingEnabled"
					(closeFilter)="filterTogglerSrv.toggle(false)"
					(studyLevelSelect)="onStudyLevelSelect($event)"
				/>

				<main class="w-full">
					@if (
						(!store.isLoading() || store.isLoadingPagination()) &&
						universities()
					) {
						@if (clearingEnabled) {
							<uc-filter-sort-widget
								[total]="universities()?.total ?? 0"
								[totalPills]="store.pills().length || 0"
								[text]="universitiesFound()"
								[studyLevel]="product"
								(toggleFilter)="filterTogglerSrv.toggle(true)"
							/>
							<uc-applied-filters-bar />
							<uc-info-clearing-toggle
								product="clearing"
								class="block mb-8"
								[copy]="infoClearingToggle"
								(clearingChange)="onStudyLevelSelect($event)"
							/>

							@if (universities()?.data) {
								<div class="grid gap-10 sm:gap-8">
									@if (universities()?.data?.length! > 0) {
										@for (
											university of universities()?.data;
											track university.id
										) {
											<uc-clearing-university-card
												[uniName]="university.name"
												[uniSlug]="university.slug"
												[uniId]="university.id"
												[uniLogo]="university.logo"
												[uniCover]="university.cover_image"
												[externalUrl]="university.external_url"
												[clientFeatures]="
													university.paid_features
												"
												[saved]="university.saved"
												[recommended]="
													university.recommended_percentage
												"
												[searchTerm]="searchTerm()"
												source="universities"
												[phoneNumber]="university.phone_number"
												[displaySeeCoursesBtn]="true"
												[cleSearchOrderPosition]="
													university.order
												"
												[privacyPolicyUrl]="
													university.privacy_policy_url
												"
												[isHECoSSubject]="null"
												[degreeLevel]="na"
												[region]="na"
											/>
										}
									}

									@if (universities()?.total === 0) {
										<uc-no-result>
											<p class="text-gray-500">
												Try entering "Oxford" or "Brunel"
											</p>
										</uc-no-result>
									}

									@if (universities()?.has_more_pages) {
										<uc-university-pagination />
									}
								</div>
							}
						} @else {
							<uc-clearing-empty-state />
						}
					} @else if (store.isLoading() && !store.isLoadingPagination()) {
						<uc-universities-skeleton [filter]="false" />
					}
				</main>
			</div>
		}
	</div>
</div>
